module.exports = __webpack_public_path__ + "img/thankyou.63a8f524.gif";